import styled from 'styled-components';

const Padding = styled.div`
  padding-inline: 200px;
`;

export default Padding;
